module.exports={
  "clima": {
    "clima-issue-1": {
      "clima-issue-1-answer-4": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "clima-issue-2": {
      "clima-issue-2-answer-2": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "clima-issue-3": {
      "clima-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "clima-issue-4": {
      "clima-issue-4-answer-3": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    }
  },
  "personas-sin-vivienda": {
    "personas-sin-vivienda-issue-1": {
      "personas-sin-vivienda-issue-1-answer-2": [
        {
          "slug": "karen-bass",
          "quote": "Apoyo el propósito de la 41.18: es inaceptable que haya campamentos de personas sin hogar cerca de escuelas y centros de cuidado infantil. Sin embargo, tengo un problema con el enfoque “distrito por distrito, campamento por campamento” de la 41.18. Necesitamos un liderazgo coordinado a nivel de toda la ciudad para resolver este problema, y tenemos que asegurarnos de que las personas sin hogar tienen acceso a viviendas y servicios, porque lo que nunca aceptaré es simplemente trasladar un campamento de un barrio a otro. Eso no es una solución, es desplazar el problema.",
          "date": ""
        }
      ]
    },
    "personas-sin-vivienda-issue-2": {
      "personas-sin-vivienda-issue-2-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "personas-sin-vivienda-issue-3": {
      "personas-sin-vivienda-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "personas-sin-vivienda-issue-4": {
      "personas-sin-vivienda-issue-4-answer-6": [
        {
          "slug": "karen-bass",
          "quote": "Abordaré inmediatamente la crisis de las personas sin hogar con la construcción de más viviendas temporales y permanentes, la reforma de los sistemas de salud mental y de abuso de sustancias, y la asistencia en capacitación y búsqueda de empleo para los angelinos sin hogar.",
          "date": ""
        }
      ]
    }
  },
  "economia": {
    "economia-issue-1": {
      "economia-issue-1-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "economia-issue-2": {
      "economia-issue-2-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "Debemos proteger nuestra flota de viviendas de renta controlada y ampliar las protecciones contra el desalojo por causa justa a las propiedades multifamiliares de renta no controlada.",
          "date": ""
        }
      ]
    },
    "economia-issue-3": {
      "economia-issue-3-answer-3": [
        {
          "slug": "karen-bass",
          "quote": "Me preocupa que, si retiramos la moratoria de los desahucios demasiado pronto, más angelinos podrían quedar sin hogar. Al mismo tiempo, creo que debemos proteger a los propietarios locales, muchos de los cuales hacen frente a retos únicos agravados por la pandemia. La Ciudad debe actuar para garantizar que estos propietarios de apartamentos reciban el apoyo financiero que necesitan para salir adelante y seguir proporcionando un hogar a los angelinos.",
          "date": ""
        }
      ]
    },
    "economia-issue-4": {
      "economia-issue-4-answer-2": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "economia-issue-5": {
      "economia-issue-5-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    }
  },
  "policia": {
    "policia-issue-1": {
      "policia-issue-1-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "policia-issue-2": {
      "policia-issue-2-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "policia-issue-3": {
      "policia-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "Aumentaré de inmediato los equipos de respuesta conjunta y alternativa, que incluyen especialistas en salud mental, ayuda a las personas sin hogar y otros especialistas que pueden dar apoyo a las personas en riesgo, con el fin de liberar a los agentes de policía para que se enfoquen en los crímenes.",
          "date": ""
        }
      ]
    },
    "policia-issue-4": {
      "policia-issue-4-answer-1": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "policia-issue-5": {
      "policia-issue-5-answer-2": [
        {
          "slug": "karen-bass",
          "date": ""
        }
      ]
    },
    "policia-issue-6": {
      "policia-issue-6-answer-2": [
        {
          "slug": "karen-bass",
          "quote": "La responsabilidad comienza desde la cúpula. Como alcaldesa, trabajaré activamente para contar con líderes que asuman responsabilidades, que se comprometan a prevenir y reducir la delincuencia y que aumenten la confianza mutua entre los funcionarios y las comunidades. Estableceré objetivos y expectativas claros para el Jefe de Policía y la Comisión de Policía, y velaré porque esos objetivos se cumplan. Como alcaldesa, invertiré en agentes de policía principales y en programas de eficacia demostrada, como el programa Community Safety Partnership (asociación para la seguridad comunitaria), para promover la confianza entre los agentes y las comunidades a las cuales atienden. También seguiré apostando por programas de prevención de la delincuencia que aborden las causas de raíz.",
          "date": ""
        }
      ]
    }
  }
}